import React, { useEffect, useState } from "react";
import {
  addBidderForEvent,
  deleteBidderForEvent,
  getBidderByUuid,
} from "services";
import { Button } from "../../../../../shadcn/components/ui/button";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";

interface NICompletedComponentProps {
  bidderUuid: any;
}
export default function NICompletedComponent({
  bidderUuid,
}: NICompletedComponentProps) {
  const [loading, setLoading] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [finalApprovalStatus, setFinalApprovalStatus] = useState("pending");
  const [bidder, setBidder] = useState<any>(null);
  const router = useRouter();
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });

  const init = async (bidderUuid: any) => {
    setLoading(true);
    if (bidderUuid) {
      try {
        const data: any = await getBidderByUuid(bidderUuid);
        setBidder(data);
        if (data?.status === "pending") {
          setFinalApprovalStatus("pending");
        } else if (data?.status === "rejected") {
          setFinalApprovalStatus("rejected");
        } else if (data?.status === "verified") {
          setFinalApprovalStatus("verified");
        }
      } catch (error) {
        console.log("error: ", error);
      }
    }
    setLoading(false);
  };
  useEffect(() => {
    init(bidderUuid);
  }, [bidderUuid]);

  const handleRetryKycRequest = async () => {
    setIsRedirecting(true);
    console.log("bidderUuid", bidderUuid);
    await deleteBidderForEvent(bidderUuid);
    let payload: any = {
      email: onboardingData.email,
      name: onboardingData.name,
      mobile_number: onboardingData?.mobile,
    };
    payload["event_uuid"] = bidder.event_uuid;
    payload["status"] = "pending";
    payload["created_by"] = "user";
    payload["meta"] = { ...bidder.meta, is_re_kyc: true };
    const response: any = await addBidderForEvent(payload);
    router.replace(`/kyc/${response.uuid}`).then(() => {
      setIsRedirecting(false);
    });
  };

  return (
    <div>
      {loading ? (
        <div className="flex flex-col flex-grow h-full">
          <div className="flex justify-center items-center">
            <div className="w-12 h-12 border-8 border-t-6 border-brand-orange rounded-full animate-spin bg-gradient-to-r from-brand-orange to-blue-100 shadow-lg"></div>
          </div>
        </div>
      ) : (
        <div>
          <h2 className="text-xl font-semibold mb-4">Submission Completed</h2>
          <div className="mt-8 mb-14">
            {finalApprovalStatus === "pending" && <KYCApprovalPending />}
            {finalApprovalStatus === "verified" && <KYCApproved />}
            {finalApprovalStatus === "rejected" && (
              <KYCApprovalRejected
                bidder={bidder}
                handleRetryKycRequest={handleRetryKycRequest}
                isRedirecting={isRedirecting}
              />
            )}
          </div>
          <div>
            {/* <div className="flex items-center space-x-3 p-4 bg-green-100 border-l-4 border-green-500 rounded-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            className="w-6 h-6 text-green-600"
          >
            <circle
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeMiterlimit={10}
              cx={16}
              cy={16}
              r={12}
            />
            <rect x={15} y={14} width={2} height={8} fill="currentColor" />
            <rect x={15} y={10} width={2} height={2} fill="currentColor" />
          </svg>
          <p className="text-green-800 text-sm font-medium">
            {`Your KYC has been approved by the banker. You can now view your event -  
          in the My Events section.`}
          </p>
        </div> */}
          </div>
        </div>
      )}
    </div>
  );
}
const KYCApprovalPending = () => {
  return (
    <div className="flex items-center space-x-3 p-4 bg-green-100 border-l-4 border-green-500 rounded-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-6 h-6 text-green-600"
      >
        <circle
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeMiterlimit={10}
          cx={16}
          cy={16}
          r={12}
        />
        <rect x={15} y={14} width={2} height={8} fill="currentColor" />
        <rect x={15} y={10} width={2} height={2} fill="currentColor" />
      </svg>
      <p className="text-green-800 text-sm font-medium">
        Your auction participation application is currently under review by the
        bank. This process may take some time. Please check back later.
      </p>
    </div>
  );
};
const KYCApproved = () => {
  return (
    <div className="flex items-center space-x-3 p-4 bg-green-100 border-l-4 border-green-500 rounded-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-6 h-6 text-green-600"
      >
        <circle
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeMiterlimit={10}
          cx={16}
          cy={16}
          r={12}
        />
        <rect x={15} y={14} width={2} height={8} fill="currentColor" />
        <rect x={15} y={10} width={2} height={2} fill="currentColor" />
      </svg>
      <p className="text-green-800 text-sm font-medium">
        {`Your Application has been approved by the banker. You can now view your event
in the My Events section.`}
      </p>
    </div>
  );
};
interface KYCApprovalRejectedProps {
  bidder: any;
  handleRetryKycRequest: any;
  isRedirecting: boolean;
}
const KYCApprovalRejected = ({
  bidder,
  handleRetryKycRequest,
  isRedirecting,
}: KYCApprovalRejectedProps) => {
  return (
    <div className="flex items-center space-x-3 px-8 py-8 bg-brand-lightOrange rounded-sm">
      <div>
        <p className="text-brand-textBlack text-base font-semibold pb-6">
          Your bid participation application has been rejected by the banker
        </p>
        <p className="text-yellow-800 text-xs font-medium">
          <span className="text-brand-textBlack font-semibold">
            Rejection Reason :
          </span>{" "}
          <span className="text-gray-500">{`${
            bidder?.remarks || "Rejected"
          }`}</span>
        </p>
        {/* <p className="text-yellow-800 text-sm font-medium">
          Your KYC needs to be completed again. Please visit the All Events
          section to re-participate in the auction.
        </p> */}
        <div className="flex justify-center lg:justify-start mt-8">
          <Button
            disabled={isRedirecting}
            onClick={handleRetryKycRequest}
            className="w-full max-w-[350px] mid:w-[300px]"
          >
            Initiate New Participation Request
          </Button>
        </div>
      </div>
    </div>
  );
};
